// GAVION lead statuses: Settings → Lead statuses (admins).
export const leadStatusesEn = {
  title: "Lead statuses",
  intro:
    "The lead statuses, in menu and filter order. The 9 base statuses cannot be deleted, but can be renamed, recoloured and moved. An added status behaves like « In progress »: the lead stays in the call queue. A renamed status shows its new name in French and English.",
  label: "Status name",
  color: "Colour",
  drag: "Drag to move %{label}",
  move_up: "Move %{label} up",
  move_down: "Move %{label} down",
  delete: "Delete %{label}",
  add: "Add a status",
  new_status: "New status",
  save: "Save",
  saved: "Statuses saved",
  loading: "Loading the statuses…",
  deleted: "Status deleted",
  deleted_moved:
    "Status deleted: %{smart_count} lead moved |||| Status deleted: %{smart_count} leads moved",
  move_dialog: {
    title: "Delete the status « %{label} »",
    body: "%{smart_count} lead has this status. Move it to: |||| %{smart_count} leads have this status. Move them to:",
    target: "Target status",
    note: "The move triggers no automation and no webhook. Demo booked, Customer, Bad number, Do not call and Cooling down are not offered: they have side effects or guards.",
    confirm: "Move and delete",
    cancel: "Cancel",
  },
  errors: {
    forbidden: "Only an administrator can change the lead statuses.",
    invalid_lead_statuses: "The status list is invalid. Reload the page.",
    invalid_lead_status_value: "Invalid status value: %{detail}.",
    duplicate_lead_status: "Two statuses have the same value: %{detail}.",
    invalid_lead_status_label:
      "Every status needs a name (60 characters at most).",
    invalid_lead_status_color: "Invalid colour (#rrggbb format).",
    missing_system_lead_status: "Missing base statuses: %{detail}.",
    lead_status_in_use:
      "Leads still have these statuses: %{detail}. Delete them one by one to choose where their leads go.",
    lead_status_in_rules:
      "This status is used by active automations: %{detail}. Change or disable them first.",
    system_lead_status: "This status cannot be deleted.",
    unknown_lead_status: "This status no longer exists. Reload the page.",
    invalid_move_target: "Pick one of the offered target statuses.",
    unknown: "Saving failed. Please try again.",
    load_failed: "Could not read the statuses. Reload the page.",
  },
};
